import { SpaceUserTable } from "./SpaceUserTable";
export var SpaceCompanyDepartmentTable;
(function (SpaceCompanyDepartmentTable) {
    let AuthorityType;
    (function (AuthorityType) {
        AuthorityType.map = {};
        AuthorityType.None = SpaceUserTable.AuthorityType.None;
        // export const ReadOnly = SpaceUserTable.AuthorityType.ReadOnly;
        // map[ReadOnly] = '読取のみ';
        AuthorityType.Editable = SpaceUserTable.AuthorityType.Editable;
        AuthorityType.map[AuthorityType.Editable] = '編集可能';
    })(AuthorityType = SpaceCompanyDepartmentTable.AuthorityType || (SpaceCompanyDepartmentTable.AuthorityType = {}));
})(SpaceCompanyDepartmentTable || (SpaceCompanyDepartmentTable = {}));
